import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";

export interface OrganisationJointCommittee{  
  id:string;
  jointCommittee:string;
  amountOfActiveEmployees:number;
  amountOfFullTimeEquivalentEmployees:number;
  workingHoursPerWeek:number;
  archived:boolean;
}


@Injectable({
  providedIn: 'root'
})

export class OrganisationJointCommitteeAdapter implements Adapter<OrganisationJointCommittee> {
  constructor(){}
  adapt(c: any, fromDepartment:boolean = false): OrganisationJointCommittee {
    return {
      id: c.id, 
      jointCommittee: c.jointCommittee.split('/').pop(), 
      workingHoursPerWeek: c.workingHoursPerWeek, 
      archived: c.archived, 
      amountOfActiveEmployees: fromDepartment ? c.amountOfActiveEmployeesInDepartment :  c.amountOfActiveEmployees, 
      amountOfFullTimeEquivalentEmployees:fromDepartment ? c.amountOfFullTimeEquivalentEmployeesInDepartment : c.amountOfFullTimeEquivalentEmployees
    } as OrganisationJointCommittee
  }
}
